import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  parametized(event) {
    event.target.value = event.target.value
          .replace(/[^a-zA-Z0-9 \-]/g, "")
          .replace(/\s+/g, "-")
  }
}
